<template>
  <div>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>

          Usuários registrados
                <v-badge
                  v-if="verificaAdmin"
                  color="green"
                  class="ml-4 mb-2"
                  :content="nusers"
                  left
                >
                </v-badge>

            </v-expansion-panel-header>
            <v-expansion-panel-content>
          <v-row class="justify-center">
            <v-col cols="12">
        <template>
          <v-data-table
            dense
            :headers="headers"
            :footer-props="footerProps"
            :items-per-page="10"
            :items="users"
            item-key="uid"
            class="striped-table elevation-0"
            >
            <template v-slot:item="{ item, index }">
              <tr :class="{'alt-row': index % 2 === 0}">
                <td v-if="item.novo" style="color:green;">{{ item.nome }}</td>
                <td v-else>{{ item.nome }}</td>
                <td>{{ item.cel }}</td>
                <td>{{ item.email }}</td>
                <td style="text-align: center;">{{ item.desc }}</td>
                <td style="text-align: center;">{{ item.tabdef }}</td>
                <td style="text-align: center;">
                  <v-btn icon color="primary" @click="selecionado(item)">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </td>
                <td v-if="item.cancel" style="color: red;">{{ "Bloqueado" }}</td>
                <td v-if="item.tabdef === '' || !item.tabdef" style="color: green;">{{ "Autorizar" }}</td>
                <td v-if="!item.cancel && !!item.tabdef">{{ "Ativo" }}</td>
            </tr>
          </template>
          </v-data-table>
        </template>
      </v-col>
      </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
  
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    :overlay="false"
    max-width="400px"
    transition="dialog-transition"
  >
  <v-card>
    <v-card-title primary-title>{{ "EDITAR" }}</v-card-title>
    <v-card-subtitle>
      {{ edit.nome }}
      <strong class="ml-3">{{ edit.email }}</strong>
    </v-card-subtitle>
    <v-card-text>
      <v-col cols="12">
        <v-row class="justify-center">
          <div width="36">
            <v-text-field
              type="number"
              color="primary"
              name="desc"
              label="Desconto"
              suffix="%"
              v-model="desc"
            ></v-text-field>
            <v-text-field
              type="number"
              color="primary"
              name="desc"
              label="Comissão"
              suffix="%"
              v-model="tabdef"
              :hint="status"
              persistent-hint
            ></v-text-field>
              <v-checkbox
                v-model="cancel"
                label="Bloquear"
              ></v-checkbox>
              <v-checkbox
                v-if="limpaNovo"
                v-model="limpaNovo"
                label="Limpa novo"
              ></v-checkbox>
          </div>
        </v-row>
      </v-col>
    </v-card-text>
    <v-card-actions>
      <v-btn color="accent" text @click="fechar()">fechar </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="editar()">salvar </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-snackbar v-model="alert" multi-line color="accent" :timeout="2000">
  {{ msg }}
  <template v-slot:action="{ attrs }">
    <v-btn color="white" text v-bind="attrs" @click="alert = false">
      X
    </v-btn>
  </template>
</v-snackbar>

</div>
</template>
<script>
  export default {
    computed: {
      users() {
        return this.$store.getters.users;
      },
      nusers() {
        return this.$store.getters.nusers;
      },
      verificaAdmin() {
        return this.$store.getters.verificaAdmin;
      },
    },
    watch: {
      users (u) {
        console.log(u)
      },
      nusers (n) {
        console.log(n)
      },
      verificaAdmin(a) {
        console.log(a)
      }
    },
    data () {
      return {
        msg: "",
        alert: false,
        dialog: false,
        edit:[],
        desc: "",
        tabdef: "",
        cancel: false,
        limpaNovo: false,
        singleSelect: true,
        status: "",
        selected: {},
        footerProps: {
          'items-per-page-text': 'Itens por página:'
        },
        headers: [
          {
            text: 'Nome',
            align: 'start',
            sortable: true,
            value: 'nome',
          },
          { text: 'Celular', value: 'cel' },
          { text: 'Email', value: 'email' },
          { text: 'Desconto', align: 'center', value: 'desc' },
          { text: 'Comissão', align: 'center', value: 'tabdef' },
          { text: 'Alterar', align: 'center', sortable: false, },
          { text: 'Status', align: 'center', sortable: false, },
        ],
      }
    },
    methods: {
      selecionado(item) {
        if(item) {
          this.edit={nome: item.nome, email: item.email}
          this.limpaNovo = item.novo || null
          this.desc = item.desc || ""
          this.tabdef = item.tabdef || ""
          this.status = item.tabdef === '' || !item.tabdef ? 'Coloque 1 para Ativar o usuário' : 'Ex: 30 ou 1 para tabela normal'
          this.cancel = item.cancel || false
          this.selected = item
          this.dialog = true
        }
      },
      editar() {
        if(this.desc === "0") {
          this.desc = ""
        }
        if(this.tabdef === "0") {
          this.tabdef = ""
        }
        const user = this.selected
        user.desc = this.desc
        user.tabdef = this.tabdef
        user.cancel = this.cancel
        // console.log(typeof this.tabdef)
        user.novo = null
        console.log(user.novo)

        this.$store.dispatch("setDesc", user)
        this.$store.dispatch("loadUsers")
        this.fechar()
        this.showAlert()
      },
      fechar() {
        this.dialog = false
        this.edit = []
        this.selected = {}
        this.desc = ""
        this.tabdef = ""
        this.cancel = false
      },
      showNews() {
        this.dialog2 = true
        console.log("Mostrar novos usuários")
      },
      showAlert() {
        this.msg = "Salvo com sucesso!!"
        this.alert = true
      }
    },
  }
</script>

<style scoped>
.striped-table .alt-row {
  background-color: #f5f5f5 !important;
}
</style>
